// Cross Icon
export const CrossIcon = () => {
  const size = 50;
  const arm = size * 0.3;
  const points = [
    { x: -arm, y: -size },
    { x: arm, y: -size },
    { x: arm, y: -arm },
    { x: size, y: -arm },
    { x: size, y: arm },
    { x: arm, y: arm },
    { x: arm, y: size },
    { x: -arm, y: size },
    { x: -arm, y: arm },
    { x: -size, y: arm },
    { x: -size, y: -arm },
    { x: -arm, y: -arm },
  ].map(p => `${p.x},${p.y}`).join(' ');

  return (
    <svg width="40" height="40" viewBox="-60 -60 120 120">
      <polygon points={points} fill="#fff" stroke="#333" strokeWidth="2" />
    </svg>
  );
};